import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { CreditBackgroundStore } from '../stores/creditBackgroundStore';

export const useCreditBackgroundStore = () =>
  useContext<{
    creditBackgroundStore: CreditBackgroundStore;
  }>(StoreContext);
